import { render } from "./SignalDetailView.vue?vue&type=template&id=0454a062"
import script from "./SignalDetailView.vue?vue&type=script&lang=js"
export * from "./SignalDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__